import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
import type { MobileNavLink } from '../MobileNavMenuData';

export default function getMobileInspirationMenuData(userContext: UserContext): MobileNavLink[][] {
  const isActiveMarketplaceUser = Boolean(userContext.has_marketplace_account);

  return [
    ...insertInArrayIf(isActiveMarketplaceUser, [
      {
        title: 'Your Favorites',
        path: '/favorites/home',
      },
    ]),
    [
      { title: 'Browse by Style', path: '/inspiration/real-weddings/' },
      { title: 'View all Inspiration', path: '/inspiration' },
    ],
  ];
}
